import React, { useState, useEffect } from 'react';
import { Checkbox, Form, Modal } from 'semantic-ui-react';
import { UserData } from '../providers/UsersProvider';
import { copyObject } from '../utility';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '../layouts';

export interface IAddUserModal {
  open: boolean;
  initialValues: UserData;

  onSubmit(_values: UserData): void;
  onCancel(): void;
}

const AddUserModal = (props: IAddUserModal) => {
  const { initialValues, open, onSubmit, onCancel } = props;
  const [values, setValues] = useState<UserData>();

  const { t } = useTranslation();

  useEffect(() => {
    setValues(initialValues);
  }, [initialValues]);

  const handleChange = (_e: any, data: any) => {
    let copy = copyObject(values);
    copy[data.name] = data.value;
    setValues(copy);
  };

  const handleToggleCheck = (_e: any, data: any) => {
    let copy = copyObject(values);
    copy[data.name] = data.checked;
    setValues(copy);
  };

  return (
    <Modal open={open} as={Form} style={{ width: 600 }}>
      {values && (
        <>
          <Modal.Header>
            {values.id ? t('users.editUser') : t('users.addNewUser')}
          </Modal.Header>
          <Modal.Content>
            <Form.Group widths={2}>
              <Form.Input
                name="firstName"
                label={t('users.firstName')}
                value={values.firstName}
                onChange={handleChange}
              />
              <Form.Input
                name="lastName"
                label={t('users.lastName')}
                value={values.lastName}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Input
              name="email"
              label={t('users.email')}
              value={values.email}
              onChange={handleChange}
            />
            <Form.Field
              control={Checkbox}
              name="systemAdmin"
              label={t('users.systemAdmin')}
              checked={values.systemAdmin}
              onChange={handleToggleCheck}
            />
            <Form.Field
              control={Checkbox}
              name="projectAdmin"
              label={t('users.projectAdmin')}
              checked={values.systemAdmin ? true : values.projectAdmin}
              onChange={handleToggleCheck}
              disabled={values.systemAdmin}
            />
            <Form.Field
              control={Checkbox}
              name="userAdmin"
              label={t('users.userAdmin')}
              checked={values.systemAdmin ? true : values.userAdmin}
              onChange={handleToggleCheck}
              disabled={values.systemAdmin}
            />
            <FlexRow fullWidth right>
              <Form.Button onClick={onCancel} color="grey">
                {t('general.cancel')}
              </Form.Button>
              <Form.Button onClick={() => onSubmit(values)} color="green">
                {t('general.save')}
              </Form.Button>
            </FlexRow>
          </Modal.Content>
        </>
      )}
    </Modal>
  );
};

export default AddUserModal;
